import React, { useCallback, useContext } from 'react'
import styled from 'styled-components'
import { withRouter } from 'react-router-dom'
import { Button } from 'antd'
import { t } from 'i18next'

import { white } from '@Constants/ThemeColor'
import { UserContext } from '@Context/User'
import { noop } from '@Core/Utility/index'
import useAuth from 'APIHooks/useAuth'
import { renderAPIErrorMsg } from '@Core/Components/TostMsg'

const LoginBtn = styled(Button)`
  color: ${white};
  font-size: 1rem;
  font-weight: bold;
  padding: 0 1rem 0 1rem;
  margin-top: -1rem;
`

const LogInOutBtn = ({ history: { push: historyPush = noop } = {} }) => {
  const [{ userAccess: { isLogin = false } = {} } = {}] =
    useContext(UserContext)
  const { loading, logoutAPI } = useAuth()

  // logout function
  const handleLogout = () => {
    logoutAPI().then((res) => {
      if (res.is_error || res?.error?.responseCode !== 100) {
        renderAPIErrorMsg(res)
      }
    })
  }

  const handlerLogin = useCallback(() => historyPush('/login'), [historyPush])

  return (
    <>
      <LoginBtn
        type="link"
        size="middle"
        onClick={isLogin ? handleLogout : handlerLogin}
        loading={loading}
      >
        {isLogin ? t('logout') : t('login')}
      </LoginBtn>
    </>
  )
}

export default withRouter(LogInOutBtn)
